export const tags = (t) => [
    { id: 'entities', label: t('discover.entities.tags.entities') },
    { id: 'recommendations', label: t('discover.entities.tags.recommendations') },
];
